// The following is to require all EF objects into the EF namespace at load

// Services
require('ef/services/asset-service');
require('ef/services/audio_hotspot');
require('ef/services/audio_player');
require('ef/services/postMessageTransporter');
require('ef/services/router');

// Models
require('ef/models/activity');
require('ef/models/activity_progress');
require('ef/models/answer');
require('ef/models/array_storage_wrapper');
require('ef/models/poll');
require('ef/models/poll_results');
require('ef/models/assessment');
require('ef/models/assessments/answer');
require('ef/models/assessments/assessment');
require('ef/models/assessments/attempt');
require('ef/models/assessments/question');
require('ef/models/evaluations/response_set');
require('ef/models/content_page');
require('ef/models/customization');
require('ef/models/enrollment');
require('ef/models/group');
require('ef/models/location');
require('ef/models/module');
require('ef/models/page');
require('ef/models/program');
require('ef/models/progress_queue');
require('ef/models/progress_tracker');
require('ef/models/question');
require('ef/models/rendered_content_page');
require('ef/models/resource');
require('ef/models/response');
require('ef/models/response_set');
require('ef/models/section');
require('ef/models/survey');
require('ef/models/action_plan_topic');
require('ef/models/action_plan_item');
require('ef/models/action_plan_item_response');

// Collections
require('ef/collections/activities_collection');
require('ef/collections/activity_progresses_collection');
require('ef/collections/answers_collection');
require('ef/collections/assessments/questions_collection');
require('ef/collections/assessments/answers_collection');
require('ef/collections/evaluations/response_set_collection');
require('ef/collections/customizations_collection');
require('ef/collections/group_collection');
require('ef/collections/locations_collection');
require('ef/collections/modules_collection');
require('ef/collections/pages_collection');
require('ef/collections/questions');
require('ef/collections/questions_collection');
require('ef/collections/resources_collection');
require('ef/collections/responses_collection');
require('ef/collections/sections_collection');
require('ef/collections/action_plan_topics_collection');
require('ef/collections/action_plan_items_collection');
require('ef/collections/action_plan_item_responses_collection');

require('ef/util');

var deprecator = require('lib/deprecator');
deprecator.mark(EF, 'EF', 'registerPage', null, '4.0.0');
deprecator.mark(EF, 'EF', 'registerPageToMultipleModules', null, '4.0.0');
deprecator.mark(EF, 'EF', 'isPageRegistered', null, '4.0.0');
deprecator.mark(EF, 'EF', 'listen', null, '4.0.0');
deprecator.mark(EF, 'EF', 'receiveMessage', null, '4.0.0');
deprecator.mark(EF, 'EF', 'getEnrollment', null, '4.0.0');
deprecator.mark(EF, 'EF', 'sortModulesBy', null, '4.0.0');
deprecator.mark(EF, 'EF', 'unlockModules', null, '4.0.0');
deprecator.mark(EF, 'EF', 'moduleGroups', null, '4.0.0');
deprecator.mark(EF, 'EF', 'moduleGroupIsComplete', null, '4.0.0');
deprecator.mark(EF, 'EF', 'incompleteModuleGroups', null, '4.0.0');
deprecator.mark(EF, 'EF', 'currentGroup', null, '4.0.0');
deprecator.mark(EF, 'EF', 'currentOrLastGroup', null, '4.0.0');
deprecator.mark(EF, 'EF', 'unlockedModules', null, '4.0.0');
deprecator.mark(EF, 'EF', 'isUnlockedByKey', null, '4.0.0');
deprecator.mark(EF, 'EF', 'getModuleByIndex', null, '4.0.0');
deprecator.mark(EF, 'EF', 'registerPageLoader', null, '4.0.0');
deprecator.mark(EF, 'EF', 'registerRouter', null, '4.0.0');
deprecator.mark(EF, 'EF', 'loadPage', null, '4.0.0');
deprecator.mark(EF, 'EF', 'reloadCurrentPage', null, '4.0.0');
deprecator.mark(EF, 'EF', '_defaultPageLoader', null, '4.0.0');
deprecator.mark(EF, 'EF', 'onDemandPageLoader', null, '4.0.0');
deprecator.mark(EF, 'EF', 'initPage', null, '4.0.0');
deprecator.mark(EF, 'EF', 'start', null, '4.0.0');
deprecator.mark(EF, 'EF', 'loadModule', null, '4.0.0');
deprecator.mark(EF, 'EF', 'initModule', null, '4.0.0');
deprecator.mark(EF, 'EF', 'loadModulesProgress', null, '4.0.0');
deprecator.mark(EF, 'EF', '_loadModulesProgressRemote', null, '4.0.0');
deprecator.mark(EF, 'EF', '_loadModulesProgressLocal', null, '4.0.0');
deprecator.mark(EF, 'EF', 'loadActivity', null, '4.0.0');
deprecator.mark(EF, 'EF', '_markPageComplete', null, '4.0.0');
deprecator.mark(EF, 'EF', 'loadNextPage', null, '4.0.0');
deprecator.mark(EF, 'EF', 'getNextPageByKey', null, '4.0.0');
deprecator.mark(EF, 'EF', 'getMostRecentPage', null, '4.0.0');
deprecator.mark(EF, 'EF', '_getContentPageObj', null, '4.0.0');
deprecator.mark(EF, 'EF', 'getContentPage', null, '4.0.0');
deprecator.mark(EF, 'EF', '_getContentPageLocal', null, '4.0.0');
deprecator.mark(EF, 'EF', '_getContentPageRemote', null, '4.0.0');
deprecator.mark(EF, 'EF', 'clearLocalProgress', null, '4.0.0');
deprecator.mark(EF, 'EF', 'registerToolbar', null, '4.0.0');
deprecator.mark(EF, 'EF', 'changeModule', null, '4.0.0');
deprecator.mark(EF, 'EF', 'pageLoader', null, '4.0.0');
deprecator.mark(EF, 'EF', 'getModuleByKey', 'EF.ModuleCollection.getModuleByKey', '4.0.0');
deprecator.mark(EF, 'EF', 'getModuleByFilter', 'EF.ModuleCollection.find', '4.0.0');

deprecator.mark(EF, 'EF', '_getSandboxHelperObj', null, '4.0.0');
deprecator.mark(EF, 'EF', 'turnOnSandboxMode', null, '4.0.0');
deprecator.mark(EF, 'EF', 'turnOffSandboxMode', null, '4.0.0');
deprecator.mark(window.SandboxHelper.prototype, 'SandboxHelper', 'postToSandbox', null, '4.0.0');
deprecator.mark(window.SandboxHelper.prototype, 'SandboxHelper', 'postPageProgress', null, '4.0.0');
deprecator.mark(window.SandboxHelper.prototype, 'SandboxHelper', 'postDynamicHeight', null, '4.0.0');
deprecator.mark(window.SandboxHelper.prototype, 'SandboxHelper', 'postContentPage', null, '4.0.0');
deprecator.mark(window.SandboxHelper.prototype, 'SandboxHelper', 'postActivity', null, '4.0.0');
deprecator.mark(window.SandboxHelper.prototype, 'SandboxHelper', 'postPage', null, '4.0.0');
deprecator.mark(window.SandboxHelper.prototype, 'SandboxHelper', 'postModules', null, '4.0.0');
deprecator.mark(window.SandboxHelper.prototype, 'SandboxHelper', 'postActivityProgress', null, '4.0.0');
deprecator.mark(window.SandboxHelper.prototype, 'SandboxHelper', 'postEnrollment', null, '4.0.0');
deprecator.mark(window.SandboxHelper.prototype, 'SandboxHelper', 'postConfig', null, '4.0.0');
deprecator.mark(window.SandboxHelper.prototype, 'SandboxHelper', 'postOptions', null, '4.0.0');
deprecator.mark(window.SandboxHelper.prototype, 'SandboxHelper', 'postNotification', null, '4.0.0');

deprecator.mark(EF.services.assets, 'ef/services/asset-service', 'audio_hotspot', null, '4.0.0');
deprecator.mark(EF.services.assets, 'ef/services/asset-service', 'file', null, '4.0.0');
deprecator.mark(EF.services.assets, 'ef/services/asset-service', 'filePath', null, '4.0.0');
deprecator.mark(EF.services.assets, 'ef/services/asset-service', 'fileNameAlias', null, '4.0.0');
deprecator.mark(EF.services.assets, 'ef/services/asset-service', 'activityPath', null, '4.0.0');
deprecator.mark(EF.services.assets, 'ef/services/asset-service', 'pageFile', null, '4.0.0');
deprecator.mark(EF.services.assets, 'ef/services/asset-service', 'fileOverrides', null, '4.0.0');
deprecator.mark(EF.services.assets, 'ef/services/asset-service', 'pageScriptFile', null, '4.0.0');
deprecator.mark(EF.services.assets, 'ef/services/asset-service', 'scriptFile', null, '4.0.0');
deprecator.mark(EF.services.assets, 'ef/services/asset-service', 'pageCssFile', null, '4.0.0');
deprecator.mark(EF.services.assets, 'ef/services/asset-service', 'cssFile', null, '4.0.0');
deprecator.mark(EF.services.assets, 'ef/services/asset-service', 'pageTemplateFile', null, '4.0.0');
deprecator.mark(EF.services.assets, 'ef/services/asset-service', 'templateFile', null, '4.0.0');

deprecator.mark(EF.services.audio_hotspot, 'ef/services/asset-service', 'audio_hotspot', null, '4.0.0');

deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'initPlayer', null, '4.0.0');
deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'initAudio', null, '4.0.0');
deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'skipAudio', null, '4.0.0');
deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'mediaPlayPause', null, '4.0.0');
deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'mediaPlay', null, '4.0.0');
deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'mediaPause', null, '4.0.0');
deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'playSlides', null, '4.0.0');
deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'playSlideMethod', null, '4.0.0');
deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'setNarration', null, '4.0.0');
deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'muteUnmute', null, '4.0.0');
deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'mute', null, '4.0.0');
deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'unmute', null, '4.0.0');
deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'toggleNarration', null, '4.0.0');
deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'showNarration', null, '4.0.0');
deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'hideNarration', null, '4.0.0');
deprecator.mark(EF.services.audio_player, 'ef/services/audio_player', 'clear', null, '4.0.0');
